"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notFoundPageAnalytics = exports.errorPageAnalytics = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _pickBy2 = _interopRequireDefault(require("lodash/pickBy"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _cookieUtils = _interopRequireDefault(require("../../common/utils/cookieUtils"));

var _queryString = _interopRequireDefault(require("query-string"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var _pageProps = function _pageProps() {
  var props = {};

  if (typeof window !== 'undefined') {
    props.kwcid = (0, _get2.default)(_queryString.default.parse(window.location.search), 's_kwcid') || _cookieUtils.default.getCookie('s_kwcid');
    props.cid = (0, _get2.default)(_queryString.default.parse(window.location.search), 'cid');
  }

  return props;
};

var defaultPageProps = (0, _pickBy2.default)(_objectSpread({
  userId: '[[user.userInfo.response.userId]]'
}, _pageProps()));
var notFoundPageAnalytics = {
  page: [{
    condition: function condition(element, state) {
      return state.config.appName === 'member-app';
    },
    name: 'Member - 404 Page Not Found',
    properties: _objectSpread({
      title: 'Page Not Found'
    }, defaultPageProps)
  }, {
    condition: function condition(element, state) {
      return state.config.appName === 'office-app';
    },
    name: 'SP : 404',
    properties: _objectSpread({
      title: 'Page Not Found'
    }, defaultPageProps)
  }]
};
exports.notFoundPageAnalytics = notFoundPageAnalytics;
var errorPageAnalytics = {
  page: {
    name: 'Member - 500 Internal Server Error',
    properties: _objectSpread({
      title: 'Error'
    }, defaultPageProps)
  }
};
exports.errorPageAnalytics = errorPageAnalytics;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/error/errorAnalytics.js
// module id = 1346
// module chunks = 25